import { render } from "./Sherryweek.vue?vue&type=template&id=07e992da&scoped=true"
import script from "./Sherryweek.vue?vue&type=script&lang=js"
export * from "./Sherryweek.vue?vue&type=script&lang=js"

import "./Sherryweek.vue?vue&type=style&index=0&id=07e992da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e992da"]])

export default __exports__